/**
 * @file
 * Add functionality to select lists.
 */

(($, { behaviors }) => {
  /**
   * Attaches behavior for adding functionality to select lists.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches select lists functionality.
   */
  behaviors.select = {
    attach(context) {
      const $select = $(".js-select select", context);

      $select.on("change", (event) => {
        const $currentSelect = $(event.currentTarget);
        $currentSelect.addClass("is-changed");
      });
    }
  };
})(jQuery, Drupal);
